export const NetworkRequests = {
  policyDocsActionsRequired: "/user-agreements/api/v3/actions_required/",
  consentDecisions: "/user-agreements/api/v3/consent_decisions/",
  consentOptions: "/api/v3/agreements/consent_options",
  createCustomer: "api/v3/customers",
  createVeriffSession: (id) => `/api/v3/customers/${id}/create_veriff_session`,
  customer: "/api/v3/customers",
  deleteCard: (id) => `api/v3/customers/${id}/cards`,
  getAxeptaHostedPage: (id) => `api/v3/customers/${id}/axepta`,
  getCards: (id) => `api/v3/customers/${id}/cards`,
  getRegistrationStatus: (id) => `/api/v3/customers/${id}/registration_status`,
  isRegistrationAllowed: "/api/v3/customers/is_registration_allowed",
  linkBusinessProfile: (id) =>
    `/api/v3/customers/${id}/actions/link_business_profile`,
  login: "/api/v3/customers/authentication",
  mfaVerify: "/api/v3/customers/mfa/verify",
  mfaResend: "/api/v3/customers/mfa/resend",
  manualIdentityVerificationDocuments:
    "/api/v3/manual_identity_verification_document_specifications",
  markCardAsDefault: (id) => `api/v3/customers/${id}/cards/mark_card_to_use`,
  paymentSheet: "api/v3/payment_sheet",
  policyDocs: "/api/v3/agreements/policy_documents",
  policyDecisions: "/user-agreements/api/v3/policy_document_agreements/",
  registrationInfo: (id) => `api/v3/customers/${id}/actions/registration_info`,
  registrationSteps: (id) => `api/v3/customers/${id}/registration_steps`,
  renewToken: "/api/v3/accounts/actions/token_renew",
  resendVerificationCode: (customerId) =>
    `/api/v3/customers/${customerId}/actions/resend_verification_code/`,
  resetPassword: "/api/v3/accounts/actions/reset_password",
  resetPasswordVerify: "/api/v3/password/reset/verify",
  resetPasswordConfirm: "/api/v3/password/reset/confirm",
  saveDriverLicense: (id) => `api/v3/customers/${id}/driver_license`,
  saveMailingAddress: (id) => `api/v3/customers/${id}/mailing_address`,
  settings: "/api/v3/services/settings",
  updateCustomer: (id) => `api/v3/customers/${id}`,
  updateDocuments: (customerId) =>
    `/api/v3/manual_identity_verification_profiles/${customerId}`,
  uploadDocuments: (customerId) =>
    `/api/v3/manual_identity_verification_profiles/${customerId}/documents`,
  verifyPhoneNumber: (id) =>
    `api/v3/customers/${id}/actions/verify_phone_number`,
};
